// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"d027a775","657":"4c1b60e7"}[chunkId] + ".css";
};